import axios from 'axios'
import {
    MessageBox,
    Message,
    Loading
} from 'element-ui'
import {
} from 'element-ui'
import {
    encrypt,
    encryptDes
} from '@/utils/rsaEncrypt'
import store from '@/store'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
    timeout: 50000
})

let loadingInstance;
const loadingOptions = {
    lock: true,
    text: '加载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
    fullscreen: true,
}

class Http {
    loading(isLoading) {
        if (isLoading) {
            loadingInstance = Loading.service(loadingOptions)
        }
    }
    get(url, params, isLoading = true) {
        this.loading(isLoading)
        console.log(url);
        return service({
            url: url,
            method: 'GET',
            params: params,
            // header: headers,
        });
    }

    post(url, data = {}, isLoading = true) {
        this.loading(isLoading)

        return service({
            url: url,
            method: 'POST',
            data
        });
    }

    postencrypt(url, data = {}, isLoading = true) {
        this.loading(isLoading)
        return service({
            url: url,
            method: 'POST',
            data: encrypt(JSON.stringify(data))
        });

    }

    postDes(url, data = {}, isLoading = true) {
        this.loading(isLoading)
        const CasualKey = sessionStorage.getItem('casual')
        return service({
            url: url,
            method: 'POST',
            data: encryptDes(data, CasualKey)
        });
    }


    put(url, data = {}, isLoading = true) {
        this.loading(isLoading)
        const CasualKey = sessionStorage.getItem('casual')
        return service({
            url: url,
            method: 'PUT',
            data: encryptDes(data, CasualKey)
        });

    }

    delete(url, params, isLoading = true) {
        this.loading(isLoading)
        return service({
            url: url,
            method: 'delete',
            params
        })
    }
}


// 响应拦截
service.interceptors.response.use(
    response => {
        console.log(response, 'response');
        if (response.data?.code == 203) {
            MessageBox.confirm('您的登录已失效，可以取消以留在此页面，或再次登录', '登录失效', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                store.dispatch('user/resetToken').then(() => {
                    location.reload()
                })
            })
            const baseError = `HTTP ${response.statusCode}: ${response.data?.message || '无'}, error:${response?.error || '无'},内部错误码:${response.data?.code}`
            console.error(baseError)
            Promise.reject(baseError)
        }
        // if (response.data.code != 200) {
        //     console.log(response)
        //     const title = response.data.message || response.error || '内部异常！'
        //     Message({
        //         message: title,
        //         type: 'error',
        //         duration: 5 * 1000
        //     })
        //     const baseError =
        //         `\n ----> HTTP ${response.statusCode}: ${response.data?.message || '无'}, error:${response?.error || '无'},内部错误码:${response.data?.code}`
        //     console.error(baseError)
        //     Promise.reject(baseError)
        // }

        if (loadingInstance) {
            loadingInstance.close()
        }

        return response.data;
    },
    error => {
        let status = null
        if (error.request) {
            status = error.request
        } else if (error.response) {
            status = error.response
        }
        if (status) {
            switch (status.status) {
                case 400:
                    error.message = '(400)'
                    break
                case 403:
                    error.message = '(403)'
                    break
                case 404:
                    error.message = '(404)'
                    break
                case 408:
                    error.message = '(408)'
                    break
                case 500:
                    error.message = '(500)'
                    break
                case 501:
                    error.message = '(501)'
                    break
                case 502:
                    error.message = '(502)'
                    break
                case 503:
                    error.message = '(503)'
                    break
                case 504:
                    error.message = '(504)'
                    break
                case 505:
                    error.message = '(505)'
                    break
                default:
                    error.message = status.error
            }
        }
        Message({
            message: '服务器繁忙，请稍后重试！' + error.message,
            type: 'error',
            duration: 5 * 1000
        })

        if (loadingInstance) {
            loadingInstance.close()
        }

        return Promise.reject(error)
    }
)

// todo 请求拦截,绑定用户令牌token。路由白名单。
service.interceptors.request.use(config => {
    console.log(config, "config");
    // 请求前缀配置
    config.baseURL = process.env.VUE_APP_BASE_API
    // 请求接口时加载
    if (store.getters.token) {
        config.headers['Authorization'] = sessionStorage.getItem('Authorization') // 让每个请求携带自定义token，可根据实际情况修改。
        config.headers['token'] = sessionStorage.getItem('token')
    }
    return config
}, (error) => {
    return Promise.reject(error)
})
const http = new Http()
export {
    http,
    service as axios
}